import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PushNotificationService } from './shared/services/push-notification.service';
import { AuthService, UpdaterService } from '@ash-workspace/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: {
    '(document:click)': 'onUserInteraction()',
    '(document:touchstart)': 'onUserInteraction()',
    '(document:keydown)': 'onUserInteraction()',
  },
})
export class App {
  protected readonly title = signal('einkaufsliste');

  private readonly pushNotificationService = inject(PushNotificationService);
  private readonly authService = inject(AuthService);
  private readonly updaterService = inject(UpdaterService);
  private hasInitializedPush = false;
  private isPushInitializationInProgress = false;

  constructor() {
    this.updaterService.initUpdater();
  }

  protected onUserInteraction(): void {
    if (
      this.hasInitializedPush ||
      this.isPushInitializationInProgress ||
      !this.authService.isLoggedIn()
    ) {
      return;
    }

    this.isPushInitializationInProgress = true;
    void this.pushNotificationService.initializePushNotifications().finally(() => {
      this.hasInitializedPush = true;
      this.isPushInitializationInProgress = false;
    });
  }
}
